import type { ApiHotelFound, HotelFound } from './types';

function toNumber(raw: number | undefined): number {
  return typeof raw === 'number' && Number.isFinite(raw) ? raw : 0;
}

function toBool(raw: boolean | undefined): boolean {
  return !!raw;
}

function toStr(raw: string | undefined): string {
  return typeof raw === 'string' ? raw : '';
}

export function adaptHotel(api: ApiHotelFound): HotelFound {
  return {
    id: toNumber(api.id),
    name: toStr(api.name),
    isPopular: toBool(api.isPopular),
    resort: toNumber(api.resort),
    resortName: toStr(api.resortName),
    category: toNumber(api.category),
    countryId: toNumber(api.countryId),
    countryName: toStr(api.countryName),
    disabled: toBool(api.disabled),
  };
}

export function adaptHotels(list: ApiHotelFound[]): HotelFound[] {
  return list.map((item) => adaptHotel(item));
}
